export const ADD_TO_CART = 'ADD_TO_CART'
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM'

// export const SET_CART_ATTRIBUTE = 'SET_CART_ATTRIBUTE'

// export const SET_TAX_RATES = 'SET_TAX_RATES'
// export const SET_TAX_AMOUNT = 'SET_TAX_AMOUNT'
// export const SET_TAX_DETAILS = 'SET_TAX_DETAILS'

export const ADD_DISCOUNT = 'ADD_DISCOUNT'
export const REMOVE_CART_DISCOUNT = 'REMOVE_CART_DISCOUNT'

// export const APPLY_GIFT_CARD = 'APPLY_GIFT_CARD'
// export const APPLY_PROMO_CODE = 'APPLY_PROMO_CODE'
// export const APPLY_DISCOUNT = 'APPLY_DISCOUNT'
// export const APPLY_DEDUCTION = 'APPLY_DEDUCTION'
// export const APPLY_DISCOUNT_RATE = 'APPLY_DISCOUNT_RATE'
// export const APPLY_DEDUCTION_RATE = 'APPLY_DEDUCTION_RATE'
// export const SET_DISCOUNT_DETAILS = 'SET_DISCOUNT_DETAILS'
// export const SET_DEDUCTION_DETAILS = 'SET_DEDUCTION_DETAILS'

export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const CLEAR_CART = 'CLEAR_CART'

export const SET_BILLING_DETAILS = 'SET_BILLING_DETAILS'

export const SET_QUESTIONNAIRE_DETAILS = 'SET_QUESTIONNAIRE_DETAILS'

export const SET_CART_ITEM_COUNT = 'SET_CART_ITEM_COUNT'

export const SET_INCOMPLETE_ORDER_ID = 'SET_INCOMPLETE_ORDER_ID'
